document.addEventListener('DOMContentLoaded', function() {
    // Get all h4 headings
    const headings = document.querySelectorAll('h4');
    const availableLetters = [];
    let currentFilter = "all";
    const filterContainer = document.querySelector('.text-brands__alphabet-nav');

    // Extract available letters from headings
    headings.forEach(h => {
        const letter = h.textContent.trim().charAt(0).toUpperCase();
        if (letter && !availableLetters.includes(letter)) {
            availableLetters.push(letter);
        }
    });

    // Sort letters alphabetically
    availableLetters.sort();

    // Create Show All button
    const resetBtn = document.createElement('button');
    resetBtn.textContent = 'All';
    resetBtn.classList.add("alphabet-link", "all-brands", "active"); // Start with active state
    resetBtn.dataset.filter = 'all';
    resetBtn.addEventListener('click', () => {
        // Toggle functionality - if already showing all, do nothing special
        if (currentFilter === "all") {
            return; // Already showing all
        }
        
        showAllEntries();
        setActiveButton("all");
        currentFilter = "all";
    });
    filterContainer.appendChild(resetBtn);

    // Create buttons for available letters
    availableLetters.forEach(letter => {
        const button = document.createElement('button');
        button.textContent = letter;
        button.dataset.filter = letter;
        button.classList.add("alphabet-link");
        button.addEventListener('click', () => {
            // Toggle functionality - if clicking the same letter, show all
            if (currentFilter === letter) {
                // Reset to show all entries
                showAllEntries();
                setActiveButton("all");
                currentFilter = "all";
            } else {
                // Filter by selected letter
                showOnly(letter);
                setActiveButton(letter);
                currentFilter = letter;
            }
        });
        filterContainer.appendChild(button);
    });

    /**
     * Show only entries for the selected letter
     * @param {string} letter - The letter to filter by
     */
    function showOnly(letter) {
        headings.forEach(h => {
            const headingLetter = h.textContent.trim().charAt(0).toUpperCase();
            const isMatch = headingLetter === letter;
            h.style.display = isMatch ? 'block' : 'none';

            // Hide/show all content until the next h4
            let sibling = h.nextElementSibling;
            while (sibling && sibling.tagName !== 'H4') {
                sibling.style.display = isMatch ? 'block' : 'none';
                sibling = sibling.nextElementSibling;
            }
        });
    }

    /**
     * Show all entries (remove all filters)
     */
    function showAllEntries() {
        headings.forEach(h => {
            h.style.display = 'block';
            
            // Show all content until the next h4
            let sibling = h.nextElementSibling;
            while (sibling && sibling.tagName !== 'H4') {
                sibling.style.display = 'block';
                sibling = sibling.nextElementSibling;
            }
        });
    }

    /**
     * Update the active state of alphabet buttons
     * @param {string} activeFilter - The filter that should be marked as active
     */
    function setActiveButton(activeFilter) {
        const allButtons = filterContainer.querySelectorAll('.alphabet-link');
        allButtons.forEach(btn => {
            btn.classList.remove('active');
            if (btn.dataset.filter === activeFilter) {
                btn.classList.add('active');
            }
        });
    }
});